














































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Http from "front-component/Http";
import _ from "lodash";
import FileRepository from "@/repositories/FileRepository";
import CatalogRepository from "@/repositories/zero-waste/CatalogRepository";
import * as Constants from "@/Constants";
import EventBus from "front-component/EventBus";
import {Action, Getter} from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";
import filters from "@/filters";

export interface Document {
    link: string;
    clientOriginalFileName: string;
    createdBy: {
        displayName: string;
    };
    createdAt: string;
    type: string;
    uuid: string;
}

export interface Catalog {
    uuid?: string;
    code: string;
    name: string;
    startDate: string;
    document: Document | null;
    typeCatalog: string;
    armisValidation: boolean;
}

@Component
export default class CatalogForm extends Vue {

    @Prop({default: null}) public catalog !: Catalog | null;
    @Prop({default: false}) public visible !: boolean;
    private loadingDocument: boolean = false;
    private loadingImage: boolean = false;
    private fileList: any[] = [];
    private document: any = "";
    private catalogImageUrl: string = "";
    private catalogData: Catalog | null = null;
    private imagePreview: string | null = null;
    private typeCatalogs: string[] = [];

    @Getter("getCurrentOwner") public currentOwner!: Owner;
    @Action("loadOwners") protected loadOwners!: () => Promise<void>;

    @Watch("catalog")
    public onCatalogChange(value: any): void {
        this.initializeCatalogData(value);
        this.initTypeCatalogs();
    }

    public mounted() {
        this.initializeCatalogData(this.catalog);
    }

    public handleFileChange(file: any, fileList: File[]) {
        const reader = new FileReader();
        reader.onload = (e: ProgressEvent<FileReader>) => {
            this.imagePreview = e.target?.result as string;
            this.catalogImageUrl = "";
        };
        reader.readAsDataURL(file.raw);
        this.fileList = [file];
    }

    private initializeCatalogData(value: any): void {
        this.imagePreview = null;
        this.catalogData = value ? _.cloneDeep(value) : {
            code: "",
            name: "",
            startDate: "",
            document: null,
            owner: this.currentOwner,
            typeCatalog: ""
        };
        this.getCatalogImg();
    }

    private initTypeCatalogs() {
        CatalogRepository.get({
            fields: ["typeCatalog"],
            filters: {
                ownerUuid: this.currentOwner.uuid,
                typeCatalog: true
            }
        }).then((data: any) => {
            this.typeCatalogs = data.map((item: any) => item.typeCatalog);
        });
    }

    public handleError(err: Error, file: File, fileList: File[]) {
        EventBus.$emit("error-alert", _.invoke(this.$options.filters, "trans", "errorUploadFile"));
        this.loadingDocument = false;
    }

    public get uploadDocument(): string {
        return FileRepository.getUploadUrl();
    }

    public get headers(): object {
        return Http.getBaseObject().getHeaders();
    }

    public get canSave(): boolean {
        return !!this.catalogData && !!this.catalogData.code && !!this.catalogData.name && !!this.catalogData.startDate;
    }

    public saveCatalog() {
        if (!this.catalogData) {
            return;
        }
        const requestCatalog = {
            code: this.catalogData.code,
            name: this.catalogData.name,
            document: this.document ? {uuid: this.document} : null,
            startDate: this.catalogData.startDate,
            owner: this.currentOwner,
            typeCatalog: this.catalogData.typeCatalog,
            armisValidation: this.catalogData.armisValidation
        };
        if (this.catalogData.uuid) {
            this.$set(requestCatalog, "uuid", this.catalogData.uuid);
        }
        CatalogRepository.save(requestCatalog).then((data: object) => {
            this.fileList = [];
            this.document = "";
            this.imagePreview = null;
            this.$emit("updateCatalog", data);
            this.getCatalogImg();
            this.$emit("update:visible", false);
            this.$emit("close");
            this.$message({
                showClose: true,
                duration: 10000,
                message: _.invoke(this.$options.filters, "trans", "catalogSaved"),
                type: "success"
            });
        });
    }

    public handleSuccess(response: Response, file: File, fileList: File[]) {
        this.document = _.get(response, "data.uuid");
        this.loadingDocument = false;
    }

    public getCatalogImg() {
        if (!this.catalogData || !this.catalogData.document) {
            return;
        }
        this.loadingImage = true;
        this.document = this.catalogData.document.uuid;
        Http.download(
            this.catalogData.document.link,
            {},
            (result: ArrayBuffer) => {
                const blob = new Blob([result]);
                this.catalogImageUrl = URL.createObjectURL(blob);
                this.loadingImage = false;
            },
            () => {
                this.loadingImage = false;
                this.$message.error("Error downloading the image.");
            }
        );
    }

    public beforeFileUpload(file: any): boolean {
        const isValidFileSize = file.size / 1024 / 1024 < 20;

        const allFileTypes: any = Constants.fileType;

        if (!isValidFileSize) {
            EventBus.$emit("error-alert", _.invoke(this.$options.filters, "trans", "invalidFileSize"));
            return false;
        }

        const acceptedFileType = -1 !== _.findIndex(allFileTypes, (fileType: any) => {
            return fileType.type === file.type;
        });

        if (!acceptedFileType) {
            EventBus.$emit("error-alert", _.invoke(this.$options.filters, "trans", "invalidFileType"));
            return false;
        }

        return true;
    }

    public loadDocument(event: Event, file: File, fileList: File[]) {
        this.loadingDocument = true;
    }

    public cancel() {
        this.document = null;
        this.fileList = [];
        this.catalogImageUrl = "";
        this.$emit("update:visible", false);
        this.$emit("close");
    }

    public closed() {
        this.$emit("close");
    }
}
